// dateTo/dateFrom are date-only comparisons — their value must not carry a time part.
export const isDateOnlyMatchMode = (matchMode?: string) =>
  matchMode === 'dateTo' || matchMode === 'dateFrom';
